import { ArrowUpRight } from 'lucide-react'
import type { ResourceLanguage } from '../content/resources'
import { TelegramLogo } from '@/components/organisms/integrations/integration-logos'
import { Button } from '@/components/ui/button'
import { trackClickTelegram } from '@/shared/analytics'
import { TELEGRAM_CHANNEL_URL } from '@/shared/constants'

const TELEGRAM_COPY: Record<
  ResourceLanguage,
  { title: string; body: string; buttonLabel: string }
> = {
  en: {
    title: 'Telegram — a channel about Laplace',
    body: 'Important events, updates, and notes on the service from the founder of Laplace.',
    buttonLabel: 'Open the Telegram channel',
  },
  ru: {
    title: 'Telegram — канал о Laplace',
    body: 'Важные события, обновления и заметки о развитии сервиса — от основателя Laplace.',
    buttonLabel: 'Открыть Telegram-канал',
  },
}

type ResourceTelegramCtaProps = {
  language: ResourceLanguage
  placement: 'index' | 'article'
}

export function ResourceTelegramCta({
  language,
  placement,
}: ResourceTelegramCtaProps) {
  const content = TELEGRAM_COPY[language]
  const headingId = `telegram-channel-heading-${placement}`

  return (
    <section
      aria-labelledby={headingId}
      className="mb-8 rounded-[1.35rem] border border-border bg-card/85 p-5 sm:flex sm:items-center sm:justify-between sm:gap-8 sm:p-6"
    >
      <div className="flex min-w-0 items-start gap-4">
        <TelegramLogo className="size-10 shrink-0" />
        <div className="min-w-0">
          <h2 id={headingId} className="font-semibold text-foreground">
            {content.title}
          </h2>
          <p className="mt-1 text-sm leading-6 text-muted-foreground">
            {content.body}
          </p>
        </div>
      </div>
      <Button
        asChild
        variant="outline"
        className="mt-5 w-full shrink-0 rounded-xl border-input bg-card text-foreground hover:bg-muted hover:text-foreground sm:mt-0 sm:w-auto"
      >
        <a
          href={TELEGRAM_CHANNEL_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            trackClickTelegram({
              source: `resources_${placement}`,
              language,
              button_text: content.buttonLabel,
            })
          }
        >
          {content.buttonLabel}
          <ArrowUpRight className="size-4" aria-hidden="true" />
        </a>
      </Button>
    </section>
  )
}
